// src/pages/requisiciones/RequisicionDetailPage.js
import React, { useState, useEffect } from 'react';
import { 
  Card, Button, Badge, Table, Alert, Spinner, Row, Col, Modal, Form 
} from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import moment from 'moment';
import {
  obtenerRequisicion,
  cambiarEstadoRequisicion,
  agregarProveedorRequisicion,
  actualizarProveedorRequisicion,
  emitirOrdenCompraRequisicion,
  aprobarOrdenCompraRequisicion,
  enviarOCProveedorRequisicion,
  adjuntarCertificadoRequisicion,
  marcarCertificadosRecibidosRequisicion,
  seleccionarGanadorRequisicion,
  enviarLinksProveedoresRequisicion
} from '../../services/requisiciones/requisicionService';
// listarProveedores ya no se usa (TIN-23 P4 → SelectorProveedorTercero hace búsqueda async)
import { useAuth } from '../../hooks/useAuth';
import { Alertassw } from '../../components/Alertas/Alertassw';
import RequisicionTimeline from '../../components/requisiciones/RequisicionTimeline';
import SeleccionarGanadorModal from '../../components/requisiciones/SeleccionarGanadorModal';
import DevolucionModal from '../../components/requisiciones/DevolucionModal';
import SelectorProveedorTercero from '../../components/Finanzas/SelectorProveedorTercero';
import ConfirmarEnvioEmailModal from '../../components/requisiciones/ConfirmarEnvioEmailModal';
import { urlSegura } from '../../utils/urlSegura';
import {
  SELECCIONAR_GANADOR_REQUISICION,
  GESTIONAR_CERTS_REQUISICION,
  APPROVEREQUISICION
} from '../../components/Roles/ConstantRoute';
// TIN-23: la autorización usa el patrón estándar del proyecto:
// userData.role.permisos + constantes de ConstantRoute.js (importadas arriba).
import { subirArchivoPublicoRequisicion, subirCertificadoPublicoRequisicion, subirArchivoRequisicion } from '../../api/common';
import Swal from 'sweetalert2';
import capitalizeText from '../../utils/capitalizeText';

const RequisicionDetailPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { userData } = useAuth();

  const [loading, setLoading] = useState(true);
  const [requisicion, setRequisicion] = useState(null);
  

  // Modal proveedores — TIN-23 P4: SelectorProveedorTercero retorna { proveedor, proveedorSinCrear }
  const [showModalProveedor, setShowModalProveedor] = useState(false);
  const [selectorProveedorValue, setSelectorProveedorValue] = useState({ proveedor: null, proveedorSinCrear: null });
  const [agregandoProveedor, setAgregandoProveedor] = useState(false);
  // OC
  const [subiendoOC, setSubiendoOC] = useState(false);
  const [procesandoOC, setProcesandoOC] = useState(false);

  // Certificados
  const [subiendoCert, setSubiendoCert] = useState({});
  const [marcandoCerts, setMarcandoCerts] = useState(false);

  // TIN-23: modales y estados nuevos
  const [showModalGanador, setShowModalGanador] = useState(false);
  const [showModalDevolucion, setShowModalDevolucion] = useState(false);
  const [enviandoMasivo, setEnviandoMasivo] = useState(false);
  const [procesandoEstado, setProcesandoEstado] = useState(false);
  // TIN-23 P1+P2: modal de confirmación de correos
  const [modalEnvioEmail, setModalEnvioEmail] = useState({
    show: false,
    titulo: '',
    descripcion: '',
    proveedoresAsignados: [], // subset (uno solo o varios)
    reenvio: false // P2: si es true, no exige estadoEnvio === 'Pendiente'
  });

  const permisos = userData?.role?.permisos || [];
  const tienePermiso = (perm) => permisos.includes(perm);
 
  const esComercial = userData?.role?.nombre === 'Comercial' || userData?.role?.nombre === 'Admin' || userData?.role?.nombre === 'Asesor Comercial';
  const esTecnico = userData?.role?.nombre === 'Técnico' || userData?.role?.nombre === 'Admin' || userData?.role?.nombre === 'Metrologo';

  // TIN-23: control de visibilidad por PERMISO (patrón estándar del proyecto).
  // El admin asigna estos permisos a los roles desde la UI de Roles → Permisos.
  // El backend mantiene validateRole(all_roles); la restricción visible la
  // aplica el frontend ocultando botones.
  const puedeAprobarRequisicion = tienePermiso(APPROVEREQUISICION);
  const puedeSeleccionarGanador = tienePermiso(SELECCIONAR_GANADOR_REQUISICION);
  const puedeGestionarCertificados = tienePermiso(GESTIONAR_CERTS_REQUISICION);

  useEffect(() => {
    cargarRequisicion();
  }, [id]);

  const cargarRequisicion = async () => {
    setLoading(true);
    try {
      const response = await obtenerRequisicion(id);
      
      if (response.status === 200 && response.data?.data) {
        setRequisicion(response.data.data);
      } else {
        Alertassw('error', 'Error', 'No se pudo cargar la requisición');
        navigate('/requisiciones');
      }
    } catch (error) {
      console.error('Error al cargar requisición:', error);
      Alertassw('error', 'Error', 'Error al cargar la requisición');
      navigate('/requisiciones');
    } finally {
      setLoading(false);
    }
  };

  // cargarProveedores removido: TIN-23 P4 usa SelectorProveedorTercero (búsqueda async + fallback ERP)

  const handleCambiarEstado = async (nuevoEstado, observacion = '') => {
    const result = await Swal.fire({
      title: '¿Está seguro?',
      text: `¿Desea cambiar el estado a ${nuevoEstado.replace(/_/g, ' ')}?`,
      icon: 'question',
      input: 'textarea',
      inputLabel: 'Observación (opcional)',
      inputValue: observacion,
      showCancelButton: true,
      confirmButtonText: 'Sí, cambiar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#0d6efd'
    });

    if (!result.isConfirmed) return;

    try {
      const response = await cambiarEstadoRequisicion(id, {
        estado: nuevoEstado,
        observacion: result.value || observacion
      });

      if (response.status === 200) {
        Alertassw('success', 'Éxito', 'Estado actualizado correctamente');
        cargarRequisicion();
      } else {
        Alertassw('error', 'Error', response.data?.message || 'Error al cambiar el estado');
      }
    } catch (error) {
      console.error('Error al cambiar estado:', error);
      Alertassw('error', 'Error', 'Error al cambiar el estado');
    }
  };

  const handleAbrirModalProveedor = () => {
    // TIN-23 P4: ya no necesitamos cargar todos los proveedores localmente.
    // El SelectorProveedorTercero hace búsqueda async + fallback al ERP.
    setSelectorProveedorValue({ proveedor: null, proveedorSinCrear: null });
    setShowModalProveedor(true);
  };

  const handleAgregarProveedor = async () => {
    const proveedor = selectorProveedorValue?.proveedor;
    if (!proveedor) {
      Alertassw('toast', 'Seleccione un proveedor', '', 'warning');
      return;
    }

    // Verificar que no esté ya agregado
    if (requisicion.proveedoresAsignados?.some(p => p.proveedor?._id === proveedor._id)) {
      Alertassw('toast', 'Este proveedor ya está asignado', '', 'warning');
      return;
    }

    setAgregandoProveedor(true);
    try {
      const response = await agregarProveedorRequisicion(id, {
        proveedorId: proveedor._id
      });

      if (response.status === 200) {
        Alertassw('success', 'Éxito', 'Proveedor agregado correctamente');
        setShowModalProveedor(false);
        setSelectorProveedorValue({ proveedor: null, proveedorSinCrear: null });
        cargarRequisicion();
      } else {
        Alertassw('error', 'Error', response.data?.message || 'Error al agregar proveedor');
      }
    } catch (error) {
      console.error('Error al agregar proveedor:', error);
      Alertassw('error', 'Error', 'Error al agregar proveedor');
    } finally {
      setAgregandoProveedor(false);
    }
  };

  // TIN-23 P1: abre el modal de confirmación de correos antes de enviar el link
  const handleEnviarProveedor = (proveedorAsignadoId, nombreProveedor) => {
    const pa = (requisicion.proveedoresAsignados || []).find(p => p._id === proveedorAsignadoId);
    if (!pa) return;
    setModalEnvioEmail({
      show: true,
      titulo: `Enviar link a ${nombreProveedor || pa.proveedor?.nombre || 'proveedor'}`,
      descripcion: 'Confirma o ajusta el correo destino antes de enviar el link de cotización.',
      proveedoresAsignados: [pa],
      reenvio: false
    });
  };

  // TIN-23 P2: reenviar link a un proveedor que ya estaba en estado Enviado/Aceptado.
  const handleReenviarLink = (proveedorAsignadoId, nombreProveedor) => {
    const pa = (requisicion.proveedoresAsignados || []).find(p => p._id === proveedorAsignadoId);
    if (!pa) return;
    setModalEnvioEmail({
      show: true,
      titulo: `Reenviar link a ${nombreProveedor || pa.proveedor?.nombre || 'proveedor'}`,
      descripcion: 'El correo registrado se cargó automáticamente. Puedes ajustarlo si por algún motivo es otro.',
      proveedoresAsignados: [pa],
      reenvio: true
    });
  };

  // Ejecutor único: envía el link (creando email) por cada proveedor del modal,
  // pasando `correoOverride` al backend.
  const ejecutarEnvioLinks = async (envios) => {
    const resultados = [];
    let exitosos = 0;
    for (const { proveedorAsignadoId, correoOverride } of envios) {
      try {
        const response = await actualizarProveedorRequisicion(id, proveedorAsignadoId, {
          estadoEnvio: 'Enviado',
          correoOverride
        });
        if (response.status === 200) {
          exitosos++;
        } else {
          resultados.push({ proveedorAsignadoId, error: response.data?.message || 'Error desconocido' });
        }
      } catch (e) {
        resultados.push({ proveedorAsignadoId, error: e?.response?.data?.message || e.message });
      }
    }
    setModalEnvioEmail((prev) => ({ ...prev, show: false }));
    if (resultados.length === 0) {
      Alertassw('success', 'Éxito', `Link enviado a ${exitosos} proveedor(es)`);
    } else {
      Swal.fire({
        icon: 'warning',
        title: `${exitosos} enviado(s), ${resultados.length} con error`,
        html: `<ul style="text-align:left">${resultados.map(r => `<li>${r.error}</li>`).join('')}</ul>`
      });
    }
    cargarRequisicion();
  };

  const copiarLink = (token) => {
    const link = `${window.location.origin}/requisiciones/publica/${token}`;
    navigator.clipboard.writeText(link);
    Alertassw('toast', 'Link copiado al portapapeles', '', 'success');
  };

  // TIN-23 P6: labels genéricos sin "Comercial"
  const ESTADO_LABEL = {
    'Borrador': 'Borrador',
    'Enviada_Comercial': 'Enviada para Aprobación',
    'Aprobada_Comercial': 'Aprobada',
    'Enviada_Proveedor': 'Enviada a Proveedor',
    'Cotizacion_Recibida': 'Cotización Recibida',
    'Orden_Compra_Emitida': 'OC Emitida',
    'Orden_Compra_Aprobada': 'OC Aprobada',
    'Orden_Enviada_Proveedor': 'OC Enviada al Proveedor',
    'Certificados_Pendientes': 'Certificados Pendientes',
    'Certificados_Recibidos': 'Certificados Recibidos',
    'Revision_Entrega': 'Revisión Entrega',
    'Devolucion': 'Devolución',
    'Rechazada': 'Rechazada',
    'Cerrada': 'Cerrada'
  };

  const getEstadoBadge = (estado) => {
    const estados = {
      'Borrador': { bg: 'secondary', icon: 'pencil' },
      'Enviada_Comercial': { bg: 'info', icon: 'send' },
      'Aprobada_Comercial': { bg: 'success', icon: 'check-circle' },
      'Enviada_Proveedor': { bg: 'warning', icon: 'truck' },
      'Cotizacion_Recibida': { bg: 'primary', icon: 'file-earmark-text' },
      'Orden_Compra_Emitida': { bg: 'warning', icon: 'file-earmark-ruled' },
      'Orden_Compra_Aprobada': { bg: 'success', icon: 'file-earmark-check' },
      'Orden_Enviada_Proveedor': { bg: 'info', icon: 'send-check' },
      'Certificados_Pendientes': { bg: 'warning', icon: 'patch-question' },
      'Certificados_Recibidos': { bg: 'success', icon: 'patch-check' },
      'Revision_Entrega': { bg: 'warning', icon: 'search' },
      'Devolucion': { bg: 'danger', icon: 'arrow-counterclockwise' },
      'Rechazada': { bg: 'danger', icon: 'x-circle' },
      'Cerrada': { bg: 'dark', icon: 'lock' }
    };

    const est = estados[estado] || estados['Borrador'];

    return (
      <Badge bg={est.bg} className="fs-6">
        <i className={`bi bi-${est.icon} me-1`}></i>
        {ESTADO_LABEL[estado] || estado?.replace(/_/g, ' ')}
      </Badge>
    );
  };

  // ── Handlers Orden de Compra ──────────────────────────────────────────────

  const handleSubirOC = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 15 * 1024 * 1024) {
      Swal.fire('Error', 'El archivo no debe superar los 15MB', 'error');
      return;
    }
    setSubiendoOC(true);
    try {
      // A3: subida interna autenticada → queda en /requisiciones/{CONSECUTIVO}/orden-compra/
      const uploadRes = await subirArchivoRequisicion(id, 'orden-compra', file);
      if (uploadRes.status !== 200 || !uploadRes.data?.url) throw new Error('Error al subir archivo');

      const res = await emitirOrdenCompraRequisicion(id, uploadRes.data.url);
      if (res.status === 200) {
        Alertassw('success', 'Éxito', 'Orden de compra emitida correctamente');
        cargarRequisicion();
      } else {
        throw new Error(res.data?.message || 'Error al emitir OC');
      }
    } catch (error) {
      console.error('Error emitir OC:', error);
      Swal.fire('Error', error.message || 'No se pudo emitir la OC', 'error');
    } finally {
      setSubiendoOC(false);
      e.target.value = '';
    }
  };

  const handleAprobarOC = async () => {
    const confirm = await Swal.fire({
      title: '¿Aprobar Orden de Compra?',
      text: 'Confirmas que revisaste la OC y está correcta para enviar al proveedor.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, aprobar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#198754'
    });
    if (!confirm.isConfirmed) return;
    setProcesandoOC(true);
    try {
      const res = await aprobarOrdenCompraRequisicion(id);
      if (res.status === 200) {
        Alertassw('success', 'Éxito', 'Orden de compra aprobada');
        cargarRequisicion();
      } else {
        throw new Error(res.data?.message || 'Error al aprobar OC');
      }
    } catch (error) {
      Swal.fire('Error', error.message, 'error');
    } finally {
      setProcesandoOC(false);
    }
  };

  const handleMarcarOCEnviadaProveedor = async () => {
    const confirm = await Swal.fire({
      title: '¿Marcar OC como enviada al proveedor?',
      text: 'Confirma que el proveedor ya recibió la orden de compra.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, marcar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#0d6efd'
    });
    if (!confirm.isConfirmed) return;
    setProcesandoOC(true);
    try {
      const res = await enviarOCProveedorRequisicion(id);
      if (res.status === 200) {
        Alertassw('success', 'Éxito', 'OC marcada como enviada al proveedor');
        cargarRequisicion();
      } else {
        throw new Error(res.data?.message || 'Error');
      }
    } catch (error) {
      Swal.fire('Error', error.message, 'error');
    } finally {
      setProcesandoOC(false);
    }
  };

  // ── Handlers Certificados ────────────────────────────────────────────────

  const handleSubirCertificado = async (e, proveedorAsignadoId, tokenPublico) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 20 * 1024 * 1024) {
      Swal.fire('Error', 'El archivo no debe superar los 20MB', 'error');
      return;
    }
    setSubiendoCert(prev => ({ ...prev, [proveedorAsignadoId]: true }));
    try {
      const uploadRes = await subirCertificadoPublicoRequisicion(tokenPublico, file);
      if (uploadRes.status !== 200 || !uploadRes.data?.url) throw new Error('Error al subir archivo');
      const res = await adjuntarCertificadoRequisicion(id, proveedorAsignadoId, [uploadRes.data.url]);
      if (res.status === 200) {
        Alertassw('success', 'Éxito', 'Certificado adjuntado correctamente');
        cargarRequisicion();
      } else {
        throw new Error(res.data?.message || 'Error al adjuntar certificado');
      }
    } catch (error) {
      console.error('Error adjuntar certificado:', error);
      Swal.fire('Error', error.message || 'No se pudo adjuntar el certificado', 'error');
    } finally {
      setSubiendoCert(prev => ({ ...prev, [proveedorAsignadoId]: false }));
      e.target.value = '';
    }
  };

  const handleMarcarCertsRecibidos = async () => {
    const confirm = await Swal.fire({
      title: '¿Marcar certificados como recibidos?',
      text: 'Esto cambiará el estado de la requisición a "Certificados Recibidos".',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, marcar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#198754'
    });
    if (!confirm.isConfirmed) return;
    setMarcandoCerts(true);
    try {
      const res = await marcarCertificadosRecibidosRequisicion(id);
      if (res.status === 200) {
        Alertassw('success', 'Éxito', 'Certificados marcados como recibidos');
        cargarRequisicion();
      } else {
        throw new Error(res.data?.message || 'Error');
      }
    } catch (error) {
      Swal.fire('Error', error.message || 'No se pudo actualizar el estado', 'error');
    } finally {
      setMarcandoCerts(false);
    }
  };

  // ── TIN-23: handlers nuevos ────────────────────────────────────────────────

  // TIN-23 P1: abre el modal con TODOS los proveedores pendientes para confirmar/editar correos
  const handleEnviarMasivo = () => {
    const pendientes = (requisicion.proveedoresAsignados || []).filter(
      pa => pa.estadoEnvio === 'Pendiente'
    );
    if (pendientes.length === 0) {
      Alertassw('toast', 'No hay proveedores pendientes', '', 'info');
      return;
    }
    setModalEnvioEmail({
      show: true,
      titulo: `Enviar link a ${pendientes.length} proveedor(es)`,
      descripcion: 'Confirma o ajusta el correo de cada proveedor antes de enviar el link de cotización. El envío se hace en lote — si falla un correo, los demás continúan.',
      proveedoresAsignados: pendientes,
      reenvio: false
    });
  };

  // Ejecutor del envío masivo (post-confirmación del modal). Usa el endpoint nuevo
  // /proveedores/enviar-links con `correosOverride: { [paId]: correo }`.
  const ejecutarEnvioMasivo = async (envios) => {
    setEnviandoMasivo(true);
    try {
      const correosOverride = envios.reduce((acc, { proveedorAsignadoId, correoOverride }) => {
        if (correoOverride) acc[proveedorAsignadoId] = correoOverride;
        return acc;
      }, {});
      const res = await enviarLinksProveedoresRequisicion(id, { correosOverride });
      if (res.status === 200) {
        const { enviados, erroresEnvio = [] } = res.data || {};
        Swal.fire({
          icon: erroresEnvio.length === 0 ? 'success' : 'warning',
          title: erroresEnvio.length === 0
            ? `${enviados} email(s) enviado(s)`
            : `${enviados} enviado(s), ${erroresEnvio.length} con error`,
          html: erroresEnvio.length === 0
            ? 'Los proveedores recibirán su link único en breve.'
            : `<ul style="text-align:left">${erroresEnvio.map(e => `<li><strong>${e.proveedorNombre || e.proveedorAsignadoId}</strong>: ${e.error}</li>`).join('')}</ul>`
        });
        setModalEnvioEmail((prev) => ({ ...prev, show: false }));
        cargarRequisicion();
      } else {
        throw new Error(res.data?.message || 'Error al enviar');
      }
    } catch (error) {
      Swal.fire('Error', error?.response?.data?.message || error.message || 'No se pudo realizar el envío', 'error');
    } finally {
      setEnviandoMasivo(false);
    }
  };

  const handleSeleccionarGanador = async (proveedorAsignadoId) => {
    const res = await seleccionarGanadorRequisicion(id, proveedorAsignadoId);
    if (res.status === 200) {
      Alertassw('success', 'Éxito', 'Proveedor ganador seleccionado');
      cargarRequisicion();
    } else {
      throw new Error(res.data?.message || 'Error al seleccionar ganador');
    }
  };

  const handlePasarRevisionEntrega = async () => {
    const confirm = await Swal.fire({
      title: '¿Pasar a Revisión de Entrega?',
      text: 'Permitirá decidir si recibir a satisfacción y cerrar, o devolver al proveedor.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#ffc107'
    });
    if (!confirm.isConfirmed) return;
    setProcesandoEstado(true);
    try {
      const res = await cambiarEstadoRequisicion(id, { estado: 'Revision_Entrega' });
      if (res.status === 200) {
        Alertassw('success', 'Éxito', 'Requisición en Revisión de Entrega');
        cargarRequisicion();
      } else {
        throw new Error(res.data?.message || 'Error');
      }
    } catch (error) {
      Swal.fire('Error', error?.response?.data?.message || error.message, 'error');
    } finally {
      setProcesandoEstado(false);
    }
  };

  const handleRecibirSatisfaccion = async () => {
    const confirm = await Swal.fire({
      title: '¿Recibir a satisfacción y cerrar?',
      text: 'Esta acción cerrará la requisición y registrará la recepción conforme.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, recibir y cerrar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#198754'
    });
    if (!confirm.isConfirmed) return;
    setProcesandoEstado(true);
    try {
      const res = await cambiarEstadoRequisicion(id, { estado: 'Cerrada' });
      if (res.status === 200) {
        Alertassw('success', 'Éxito', 'Requisición cerrada por satisfacción');
        cargarRequisicion();
      } else {
        throw new Error(res.data?.message || 'Error');
      }
    } catch (error) {
      Swal.fire('Error', error?.response?.data?.message || error.message, 'error');
    } finally {
      setProcesandoEstado(false);
    }
  };

  const handleConfirmarDevolucion = async (observacionDevolucion) => {
    const res = await cambiarEstadoRequisicion(id, {
      estado: 'Devolucion',
      observacion: observacionDevolucion
    });
    if (res.status === 200) {
      Alertassw('success', 'Devuelto', 'Requisición devuelta al proveedor');
      cargarRequisicion();
    } else {
      throw new Error(res.data?.message || 'Error al devolver');
    }
  };

  // Última observación de devolución extraída del timeline (para mostrar en sección Devolucion)
  const ultimaDevolucion = (() => {
    if (!requisicion || requisicion.estado !== 'Devolucion') return null;
    const ev = [...(requisicion.timeline || [])].reverse().find(t => t.evento === 'DEVUELTA');
    return ev ? { observacion: ev.datos?.observacion || ev.descripcion, fecha: ev.fecha } : null;
  })();

  const getEstadoEnvioBadge = (estadoEnvio) => {
    // TIN-23: 'Aprobado' legacy se renderiza como 'Aceptado' (mismo badge)
    const norm = estadoEnvio === 'Aprobado' ? 'Aceptado' : estadoEnvio;
    const estados = {
      'Pendiente':  { bg: 'secondary', text: 'Pendiente' },
      'Enviado':    { bg: 'info',      text: 'Enviado' },
      'Aceptado':   { bg: 'success',   text: 'Aceptado' },
      'Rechazado':  { bg: 'danger',    text: 'Rechazado' },
      'Ganador':    { bg: 'warning',   text: '🏆 Ganador' },
      'Descartado': { bg: 'secondary', text: 'Descartado' },
    };
    const item = estados[norm] || { bg: 'secondary', text: estadoEnvio };
    return <Badge bg={item.bg}>{item.text}</Badge>;
  };

  if (loading) {
    return (
      <div className="container-fluid py-4">
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3 text-muted">Cargando requisición...</p>
        </div>
      </div>
    );
  }

  if (!requisicion) {
    return (
      <div className="container-fluid py-4">
        <Alert variant="danger">
          <i className="bi bi-exclamation-triangle me-2"></i>
          Requisición no encontrada
        </Alert>
      </div>
    );
  }

  return (
    <div className="container-fluid py-4">
      <Row className="g-3">
        {/* HEADER */}
        <Col xs={12}>
          <Card className='w-100'>
            <Card.Body className='w-100'>
              <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
                <div>
                  <h3 className="mb-2">
                    Requisición #{requisicion.consecutivo}
                  </h3>
                  <h5 className="text-muted mb-3">{requisicion.titulo}</h5>
                  <div className="d-flex gap-2 flex-wrap">
                    {getEstadoBadge(requisicion.estado)}
                    <Badge bg="light" text="dark">
                      <i className="bi bi-building me-1"></i>
                      {requisicion.areaOrigen}
                    </Badge>
                    <Badge bg="light" text="dark">
                      <i className="bi bi-person me-1"></i>
                      {requisicion.creadoPor?.nombre}
                    </Badge>
                    <Badge bg="light" text="dark">
                      <i className="bi bi-calendar me-1"></i>
                      {moment(requisicion.fechaCreacion).format('DD/MM/YYYY HH:mm')}
                    </Badge>
                  </div>
                </div>
                
                <div className="d-flex gap-2">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => navigate('/requisiciones')}
                  >
                    <i className="bi bi-arrow-left me-1"></i>
                    Volver
                  </Button>
                </div>
              </div>

              {requisicion.observacionComercial && (
                <Alert variant="info" className="mt-3 mb-0">
                  <strong>Observación:</strong> {requisicion.observacionComercial}
                </Alert>
              )}
            </Card.Body>
          </Card>
        </Col>

        {/* ITEMS — TIN-23: tabla condicional según tipoRequisicion */}
        <Col xs={12}>
          <Card className='w-100'>
            <Card.Header className="bg-light w-100 d-flex justify-content-between align-items-center flex-wrap gap-2">
              <h6 className="mb-0">
                <i className="bi bi-list-check me-2"></i>
                Items de la Requisición ({requisicion.items?.length || 0})
              </h6>
              {requisicion.tipoRequisicion === 'Servicio_General' && requisicion.tipoServicio && (
                <Badge bg="info">
                  <i className="bi bi-wrench-adjustable me-1"></i>
                  Servicio: {requisicion.tipoServicio}
                </Badge>
              )}
            </Card.Header>
            <Card.Body className='w-100'>
              {requisicion.items?.length === 0 ? (
                <Alert variant="info" className="mb-0">
                  <i className="bi bi-info-circle me-2"></i>
                  No hay items en esta requisición
                </Alert>
              ) : requisicion.tipoRequisicion === 'Servicio_General' ? (
                <div className="table-responsive">
                  <Table bordered hover size="sm">
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: '60px' }}>#</th>
                        <th>Descripción del servicio</th>
                      </tr>
                    </thead>
                    <tbody>
                      {requisicion.items.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <small style={{ whiteSpace: 'pre-wrap' }}>
                              {item.descripcionServicio || '—'}
                            </small>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <div className="table-responsive">
                  <Table bordered hover size="sm">
                    <thead className="table-light">
                      <tr>
                        <th>Tipo Actividad</th>
                        <th>Equipo</th>
                        <th>Requerimientos</th>
                      </tr>
                    </thead>
                    <tbody>
                      {requisicion.items.map((item, index) => (
                        <tr key={index}>
                          <td>{item.tipoActividad || '—'}</td>
                          <td>
                            {item.actividad?.equipo ? (
                              <small>
                                <strong>{capitalizeText(item.actividad.equipo.item || '-')}</strong><br />
                                {item.actividad.equipo.marca} - Mod: {item.actividad.equipo.modelo}<br />
                                S/N: {item.actividad.equipo.serie}
                              </small>
                            ) : (
                              <small className="text-muted">—</small>
                            )}
                          </td>
                          <td>
                            <small style={{ whiteSpace: 'pre-wrap' }}>{item.snapshotPatron?.requerimientos || '—'}</small>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>

        {/* PROVEEDORES (solo visible para comercial/admin) */}
          <Col xs={12}>
            <Card className='w-100'>
              <Card.Header className="bg-light d-flex justify-content-between align-items-center w-100 flex-wrap gap-2">
                <h6 className="mb-0">
                  <i className="bi bi-truck me-2"></i>
                  Proveedores Asignados ({requisicion.proveedoresAsignados?.length || 0})
                </h6>
                {/* TIN-23: sin tope superior. Visible mientras la requisición esté en estados editables */}
                <div className="d-flex gap-2 flex-wrap">
                  {/* TIN-23 P3: agregar proveedor en cualquier etapa razonable, mientras no haya ganador */}
                  {(() => {
                    const tieneGanador = (requisicion.proveedoresAsignados || []).some(pa => pa.estadoEnvio === 'Ganador');
                    const estadosAdmitidos = ['Borrador', 'Enviada_Comercial', 'Aprobada_Comercial', 'Enviada_Proveedor', 'Cotizacion_Recibida'];
                    if (tieneGanador || !estadosAdmitidos.includes(requisicion.estado)) return null;
                    return (
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={handleAbrirModalProveedor}
                      >
                        <i className="bi bi-plus-circle me-1"></i>
                        Agregar Proveedor
                      </Button>
                    );
                  })()}
                  {/* TIN-23: Envío masivo (mínimo 2 activos + al menos 1 pendiente) */}
                  {(() => {
                    const activos = (requisicion.proveedoresAsignados || []).filter(
                      pa => !['Rechazado', 'Descartado'].includes(pa.estadoEnvio)
                    );
                    const pendientes = activos.filter(pa => pa.estadoEnvio === 'Pendiente');
                    const habilitado = activos.length >= 2 && pendientes.length >= 1;
                    // P3: el envío masivo también disponible en más estados
                    const estadosEnvio = ['Aprobada_Comercial', 'Enviada_Proveedor', 'Cotizacion_Recibida'];
                    if (!estadosEnvio.includes(requisicion.estado)) return null;
                    return (
                      <Button
                        variant="success"
                        size="sm"
                        onClick={handleEnviarMasivo}
                        disabled={!habilitado || enviandoMasivo}
                        title={!habilitado
                          ? 'Se requieren mínimo 2 proveedores activos y al menos 1 en Pendiente.'
                          : `Enviará link a ${pendientes.length} proveedor(es) pendiente(s)`}
                      >
                        {enviandoMasivo
                          ? <><Spinner animation="border" size="sm" className="me-1" />Enviando...</>
                          : <><i className="bi bi-send me-1"></i>Enviar a {pendientes.length} pendiente{pendientes.length !== 1 ? 's' : ''}</>}
                      </Button>
                    );
                  })()}
                </div>
              </Card.Header>
              <Card.Body className='w-100'>
                {requisicion.proveedoresAsignados?.length === 0 ? (
                  <Alert variant="info" className="mb-0">
                    <i className="bi bi-info-circle me-2"></i>
                    No hay proveedores asignados
                  </Alert>
                ) : (
                  <div className="table-responsive">
                    <Table bordered hover>
                      <thead className="table-light">
                        <tr>
                          <th>Proveedor</th>
                          <th>Contacto</th>
                          <th>Estado Envío</th>
                          <th>Cotización</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {requisicion.proveedoresAsignados.map((pa) => (
                          <tr key={pa._id}>
                            <td>
                              <strong>{pa.proveedor?.nombre}</strong><br />
                              <small className="text-muted">
                                {pa.proveedor?.ciudad} | NIT: {pa.proveedor?.nit}
                              </small>
                            </td>
                            <td>
                              <small>
                                {pa.proveedor?.nombreContacto}<br />
                                {pa.proveedor?.email}<br />
                                {pa.proveedor?.telefono}
                              </small>
                            </td>
                            <td>{getEstadoEnvioBadge(pa.estadoEnvio)}</td>
                            <td>
                              {/* TIN-23 iter 3: muestra archivo, link, correo o "Sin cotización".
                                  TIN-23 iter 4: hrefs validados con urlSegura (defensa contra javascript:/data:). */}
                              {(pa.cotizacion?.archivo || pa.cotizacion?.linkPropuesta || pa.cotizacion?.correoEnvio) ? (
                                <div>
                                  {urlSegura(pa.cotizacion?.archivo) && (
                                    <div>
                                      <a href={urlSegura(pa.cotizacion.archivo)} target="_blank" rel="noopener noreferrer">
                                        <i className="bi bi-file-pdf me-1"></i>
                                        Ver archivo
                                      </a>
                                    </div>
                                  )}
                                  {urlSegura(pa.cotizacion?.linkPropuesta) && (
                                    <div>
                                      <a href={urlSegura(pa.cotizacion.linkPropuesta)} target="_blank" rel="noopener noreferrer">
                                        <i className="bi bi-link-45deg me-1"></i>
                                        Ver propuesta en línea
                                      </a>
                                    </div>
                                  )}
                                  {pa.cotizacion?.correoEnvio && (
                                    <small className="text-muted d-block">
                                      <i className="bi bi-envelope me-1"></i>
                                      {pa.cotizacion.correoEnvio}
                                    </small>
                                  )}
                                  {pa.cotizacion?.observacion && (
                                    <small className="text-muted d-block" style={{ whiteSpace: 'pre-wrap' }}>
                                      <i className="bi bi-chat-left-quote me-1"></i>
                                      {pa.cotizacion.observacion}
                                    </small>
                                  )}
                                </div>
                              ) : (
                                <span className="text-muted">Sin cotización</span>
                              )}
                            </td>
                            <td>
                              <div className="d-flex gap-1 flex-wrap">
                                {pa.estadoEnvio === 'Pendiente' && (
                                  <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => handleEnviarProveedor(pa._id, pa.proveedor?.nombre)}
                                  >
                                    <i className="bi bi-send"></i> Enviar
                                  </Button>
                                )}
                                {/* TIN-23 P2: Reenviar link (estados intermedios sin ganador/descartado) */}
                                {['Enviado', 'Aceptado', 'Aprobado'].includes(pa.estadoEnvio) && !pa.tokenExpirado && (
                                  <Button
                                    variant="outline-info"
                                    size="sm"
                                    onClick={() => handleReenviarLink(pa._id, pa.proveedor?.nombre)}
                                    title="Reenviar link (te permitirá ajustar el correo destino)"
                                  >
                                    <i className="bi bi-arrow-repeat"></i> Reenviar
                                  </Button>
                                )}
                                {/* TIN-23 iter 3: botón Seleccionar Ganador visible cuando
                                    la requisición está en Enviada_Proveedor o Cotizacion_Recibida,
                                    y este proveedor tiene cotización válida (archivo|link|correo). */}
                                {['Cotizacion_Recibida', 'Enviada_Proveedor'].includes(requisicion.estado) &&
                                 puedeSeleccionarGanador &&
                                 (pa.cotizacion?.archivo || pa.cotizacion?.linkPropuesta || pa.cotizacion?.correoEnvio) &&
                                 !['Rechazado', 'Descartado', 'Ganador'].includes(pa.estadoEnvio) && (
                                  <Button
                                    variant="warning"
                                    size="sm"
                                    onClick={() => setShowModalGanador(true)}
                                    title="Abrir modal para seleccionar al ganador entre las cotizaciones recibidas"
                                  >
                                    <i className="bi bi-trophy"></i> Seleccionar Ganador
                                  </Button>
                                )}
                                {pa.tokenPublico && !pa.tokenExpirado && (
                                  <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={() => copiarLink(pa.tokenPublico)}
                                  >
                                    <i className="bi bi-clipboard"></i>
                                  </Button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>


        {/* ORDEN DE COMPRA */}
        {['Cotizacion_Recibida','Orden_Compra_Emitida','Orden_Compra_Aprobada','Orden_Enviada_Proveedor','Certificados_Pendientes','Certificados_Recibidos','Cerrada'].includes(requisicion.estado) && (
          <Col xs={12}>
            <Card className='w-100'>
              <Card.Header className="bg-light d-flex justify-content-between align-items-center w-100">
                <h6 className="mb-0">
                  <i className="bi bi-file-earmark-ruled me-2"></i>
                  Orden de Compra
                </h6>
                {getEstadoBadge(requisicion.estado)}
              </Card.Header>
              <Card.Body className='w-100'>
                {/* Guard: la Orden de Compra solo se puede emitir/aprobar/enviar
                    cuando ya se seleccionó un proveedor Ganador entre las
                    cotizaciones. Antes la sección se habilitaba apenas la
                    requisición entraba en `Cotizacion_Recibida`, permitiendo
                    adjuntar OC sin ganador. Si ya hay OC emitida en la BD
                    (caso legacy antes de este guard) se sigue mostrando. */}
                {(() => {
                  const tieneGanador = (requisicion.proveedoresAsignados || []).some(pa => pa.estadoEnvio === 'Ganador');
                  const hayOCEmitida = Boolean(requisicion.ordenCompra?.archivo);
                  return (
                    <>
                      {/* OC ya emitida — mostrar archivo */}
                      {hayOCEmitida && (
                        <Alert variant="info" className="d-flex align-items-center justify-content-between mb-3 py-2">
                          <span>
                            <i className="bi bi-file-earmark-ruled me-2"></i>
                            {urlSegura(requisicion.ordenCompra.archivo) ? (
                              <a href={urlSegura(requisicion.ordenCompra.archivo)} target="_blank" rel="noopener noreferrer">Ver Orden de Compra</a>
                            ) : (
                              <span className="text-muted">Ver Orden de Compra</span>
                            )}
                            {requisicion.ordenCompra.fechaEmision && (
                              <small className="text-muted ms-2">— {moment(requisicion.ordenCompra.fechaEmision).format('DD/MM/YYYY HH:mm')}</small>
                            )}
                          </span>
                          {requisicion.ordenCompra.aprobadaPor && (
                            <Badge bg="success" className="ms-2">
                              <i className="bi bi-check-circle me-1"></i>
                              Aprobada
                            </Badge>
                          )}
                        </Alert>
                      )}

                      {/* Falta ganador: bloquear acciones y explicar al usuario. */}
                      {!tieneGanador && !hayOCEmitida && (
                        <Alert variant="warning" className="mb-0 py-2 d-flex align-items-center">
                          <i className="bi bi-exclamation-triangle-fill me-2"></i>
                          <div>
                            Para emitir la <strong>Orden de Compra</strong> primero debes seleccionar un proveedor <strong>Ganador</strong> entre las cotizaciones recibidas.
                          </div>
                        </Alert>
                      )}

                      {/* Acciones de OC: solo cuando ya hay ganador seleccionado
                          (o cuando la OC ya está emitida en BD, para continuar
                          el flujo legacy sin bloquearlo). */}
                      {(tieneGanador || hayOCEmitida) && (
                <div className="d-flex gap-2 flex-wrap">
                  {/* Emitir OC: Cotizacion_Recibida + permiso */}
                  {requisicion.estado === 'Cotizacion_Recibida' && tienePermiso('Emitir Orden de Compra Requisición') && (
                    <Form.Group className="d-flex align-items-center gap-2">
                      <Form.Label className="mb-0 fw-semibold">Adjuntar OC:</Form.Label>
                      <Form.Control
                        type="file"
                        accept=".pdf,.doc,.docx"
                        onChange={handleSubirOC}
                        disabled={subiendoOC}
                        style={{ maxWidth: 300 }}
                      />
                      {subiendoOC && <Spinner animation="border" size="sm" />}
                    </Form.Group>
                  )}

                  {/* Aprobar OC: Orden_Compra_Emitida + permiso */}
                  {requisicion.estado === 'Orden_Compra_Emitida' && tienePermiso('Aprobar Orden de Compra Requisición') && (
                    <Button variant="success" onClick={handleAprobarOC} disabled={procesandoOC}>
                      {procesandoOC ? <Spinner animation="border" size="sm" className="me-1" /> : <i className="bi bi-file-earmark-check me-1"></i>}
                      Aprobar Orden de Compra
                    </Button>
                  )}

                  {/* Enviar OC al proveedor: Orden_Compra_Aprobada + permiso */}
                  {requisicion.estado === 'Orden_Compra_Aprobada' && tienePermiso('Emitir Orden de Compra Requisición') && (
                    <>
                      <Button variant="primary" onClick={handleMarcarOCEnviadaProveedor} disabled={procesandoOC}>
                        {procesandoOC ? <Spinner animation="border" size="sm" className="me-1" /> : <i className="bi bi-send-check me-1"></i>}
                        Marcar como enviada al proveedor
                      </Button>
                      {/* A1: solo copiar el link del proveedor Ganador. Si aún
                          no hay ganador (caso legacy de un solo proveedor)
                          mostramos los activos no descartados. */}
                      {(() => {
                        const ganadores = (requisicion.proveedoresAsignados || []).filter(p => p.estadoEnvio === 'Ganador');
                        const visibles = ganadores.length > 0
                          ? ganadores
                          : (requisicion.proveedoresAsignados || []).filter(p => !['Rechazado', 'Descartado'].includes(p.estadoEnvio));
                        return visibles.map(pa => (
                          pa.tokenPublico && (
                            <Button
                              key={pa._id}
                              variant="outline-secondary"
                              size="sm"
                              onClick={() => copiarLink(pa.tokenPublico)}
                            >
                              <i className="bi bi-clipboard me-1"></i>
                              Copiar link — {pa.proveedor?.nombre}
                            </Button>
                          )
                        ));
                      })()}
                    </>
                  )}
                </div>
                      )}
                    </>
                  );
                })()}
              </Card.Body>
            </Card>
          </Col>
        )}

        {/* CERTIFICADOS — extendido para incluir Revision_Entrega y Devolucion (TIN-23) */}
        {['Orden_Enviada_Proveedor','Certificados_Pendientes','Certificados_Recibidos','Revision_Entrega','Devolucion','Cerrada'].includes(requisicion.estado) && (
          <Col xs={12}>
            <Card className='w-100'>
              <Card.Header className="bg-light w-100">
                <h6 className="mb-0">
                  <i className="bi bi-patch-check me-2"></i>
                  Certificados de Calibración
                </h6>
              </Card.Header>
              <Card.Body className='w-100'>
                {/* A1: solo se gestionan certificados del proveedor Ganador.
                    Si no hay ganador todavía (caso legacy o flujo antiguo),
                    mostramos los activos no descartados. */}
                {(() => {
                  const ganadores = (requisicion.proveedoresAsignados || []).filter(p => p.estadoEnvio === 'Ganador');
                  const visibles = ganadores.length > 0
                    ? ganadores
                    : (requisicion.proveedoresAsignados || []).filter(p => !['Rechazado', 'Descartado'].includes(p.estadoEnvio));
                  if (visibles.length === 0) {
                    return (
                      <Alert variant="info" className="mb-0">
                        <i className="bi bi-info-circle me-2"></i>
                        Aún no hay proveedor ganador para esta requisición.
                      </Alert>
                    );
                  }
                  return visibles.map(pa => (
                    <div key={pa._id} className="mb-4">
                      <h6 className="fw-semibold">
                        {pa.proveedor?.nombre}
                        {pa.estadoEnvio === 'Ganador' && (
                          <span className="ms-2 badge bg-warning text-dark">🏆 Ganador</span>
                        )}
                      </h6>
                      {pa.certificados && pa.certificados.length > 0 ? (
                        <div className="d-flex flex-wrap gap-2 mb-2">
                          {pa.certificados.map((cert, i) => (
                            <Alert key={i} variant="success" className="py-1 px-2 mb-0 d-flex align-items-center gap-2">
                              <i className="bi bi-file-earmark-check"></i>
                              {urlSegura(cert.archivo) ? (
                                <a href={urlSegura(cert.archivo)} target="_blank" rel="noopener noreferrer">
                                  Certificado {i + 1}
                                </a>
                              ) : (
                                <span>Certificado {i + 1}</span>
                              )}
                              <small className="text-muted">
                                — {cert.subidoPor === 'proveedor' ? 'Proveedor' : 'Interno'} · {moment(cert.fechaRecepcion).format('DD/MM/YY')}
                              </small>
                            </Alert>
                          ))}
                        </div>
                      ) : (
                        <p className="text-muted small mb-2">Sin certificados aún</p>
                      )}
                      {tienePermiso('Gestionar Certificados Requisición') && (
                        <div className="d-flex align-items-center gap-2">
                          <Form.Control
                            type="file"
                            accept=".pdf,.doc,.docx"
                            onChange={(e) => handleSubirCertificado(e, pa._id, pa.tokenPublico)}
                            disabled={subiendoCert[pa._id]}
                            style={{ maxWidth: 300 }}
                          />
                          {subiendoCert[pa._id] && <Spinner animation="border" size="sm" />}
                          <small className="text-muted">Adjuntar certificado</small>
                        </div>
                      )}
                      <hr className="my-2" />
                    </div>
                  ));
                })()}

                {/* Botón: marcar manualmente como recibidos */}
                {tienePermiso('Gestionar Certificados Requisición') &&
                  ['Certificados_Pendientes', 'Orden_Enviada_Proveedor'].includes(requisicion.estado) && (
                  <div className="mt-2 pt-2 border-top">
                    <Button
                      variant="success"
                      onClick={handleMarcarCertsRecibidos}
                      disabled={marcandoCerts}
                    >
                      {marcandoCerts
                        ? <><Spinner animation="border" size="sm" className="me-1" />Procesando...</>
                        : <><i className="bi bi-patch-check-fill me-1"></i>Marcar certificados como recibidos</>
                      }
                    </Button>
                    <small className="text-muted ms-2">
                      Confirma que se han recibido los certificados por otro medio
                    </small>
                  </div>
                )}

                {/* Aviso cuando ya están recibidos */}
                {requisicion.estado === 'Certificados_Recibidos' && (
                  <Alert variant="success" className="mb-0 mt-2 py-2 d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <span>
                      <i className="bi bi-patch-check-fill me-2"></i>
                      Todos los certificados han sido recibidos correctamente.
                    </span>
                    {/* TIN-23: pasar a Revisión Entrega */}
                    {puedeGestionarCertificados && (
                      <Button
                        variant="warning"
                        size="sm"
                        onClick={handlePasarRevisionEntrega}
                        disabled={procesandoEstado}
                      >
                        {procesandoEstado
                          ? <><Spinner animation="border" size="sm" className="me-1" />Procesando...</>
                          : <><i className="bi bi-search me-1"></i>Pasar a Revisión de Entrega</>}
                      </Button>
                    )}
                  </Alert>
                )}
              </Card.Body>
            </Card>
          </Col>
        )}

        {/* TIN-23: Sección Revisión de Entrega */}
        {requisicion.estado === 'Revision_Entrega' && puedeGestionarCertificados && (
          <Col xs={12}>
            <Card className="w-100 border-warning">
              <Card.Header className="bg-warning text-dark w-100">
                <h6 className="mb-0">
                  <i className="bi bi-search me-2"></i>
                  Revisión de Entrega
                </h6>
              </Card.Header>
              <Card.Body className="w-100">
                <p className="mb-3">
                  Revisa los certificados recibidos y decide si la entrega es satisfactoria o si
                  debe ser devuelta al proveedor con observaciones.
                </p>
                <div className="d-flex gap-2 flex-wrap">
                  <Button
                    variant="success"
                    onClick={handleRecibirSatisfaccion}
                    disabled={procesandoEstado}
                  >
                    {procesandoEstado
                      ? <><Spinner animation="border" size="sm" className="me-1" />Procesando...</>
                      : <><i className="bi bi-check2-all me-1"></i>Recibir a satisfacción y cerrar</>}
                  </Button>
                  <Button
                    variant="outline-danger"
                    onClick={() => setShowModalDevolucion(true)}
                    disabled={procesandoEstado}
                  >
                    <i className="bi bi-arrow-counterclockwise me-1"></i>
                    Devolver
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        )}

        {/* TIN-23: Sección Devolución */}
        {requisicion.estado === 'Devolucion' && (
          <Col xs={12}>
            <Card className="w-100 border-danger">
              <Card.Header className="bg-danger text-white w-100">
                <h6 className="mb-0">
                  <i className="bi bi-arrow-counterclockwise me-2"></i>
                  Devolución en curso
                </h6>
              </Card.Header>
              <Card.Body className="w-100">
                {ultimaDevolucion && (
                  <Alert variant="warning" className="mb-3">
                    <p className="mb-2 fw-semibold">
                      Última observación de devolución
                      {ultimaDevolucion.fecha && (
                        <small className="text-muted ms-2">
                          ({moment(ultimaDevolucion.fecha).format('DD/MM/YYYY HH:mm')})
                        </small>
                      )}
                    </p>
                    <blockquote
                      className="ps-3 mb-0"
                      style={{ borderLeft: '3px solid #ffc107', fontStyle: 'italic' }}
                    >
                      {ultimaDevolucion.observacion}
                    </blockquote>
                  </Alert>
                )}
                <p className="text-muted small mb-0">
                  <i className="bi bi-hourglass-split me-1"></i>
                  Esperando que el proveedor ganador suba nuevos certificados.
                  El ciclo continuará: re-entrega → Certificados Recibidos → Revisión de Entrega.
                </p>
              </Card.Body>
            </Card>
          </Col>
        )}

        {/* TIMELINE */}
        <Col xs={12}>
          <Card className='w-100'>
            <Card.Header className="bg-light w-100">
              <h6 className="mb-0">
                <i className="bi bi-clock-history me-2"></i>
                Historial de Cambios
              </h6>
            </Card.Header>
            <Card.Body className='w-100'>
              <RequisicionTimeline timeline={requisicion.timeline || []} />
            </Card.Body>
          </Card>
        </Col>

        {/* ACCIONES */}
        <Col xs={12}>
          <Card className='w-100'>
            <Card.Body className='w-100'>
              <div className="d-flex gap-2 flex-wrap justify-content-end">
                {/* TIN-23 P5: Editar permitido mientras no haya ganador ni Cerrada/Rechazada */}
                {(() => {
                  const tieneGanador = (requisicion.proveedoresAsignados || []).some(pa => pa.estadoEnvio === 'Ganador');
                  const puedeEditar = !tieneGanador && !['Cerrada', 'Rechazada'].includes(requisicion.estado);
                  return puedeEditar && (
                    <Button
                      variant="outline-primary"
                      onClick={() => navigate(`/requisiciones/editar/${id}`)}
                      title="Editar items, requerimientos o proveedores (mientras no haya ganador seleccionado)"
                    >
                      <i className="bi bi-pencil me-1"></i>
                      Editar
                    </Button>
                  );
                })()}

                {/* Técnico en Borrador: enviar para aprobación */}
                {esTecnico && requisicion.estado === 'Borrador' && (
                  <Button
                    variant="primary"
                    onClick={() => handleCambiarEstado('Enviada_Comercial')}
                  >
                    <i className="bi bi-send me-1"></i>
                    Enviar para Aprobación
                  </Button>
                )}

                {/* Aprobador en Enviada_Comercial */}
                {puedeAprobarRequisicion && requisicion.estado === 'Enviada_Comercial' && (
                  <>
                    <Button
                      variant="success"
                      onClick={() => handleCambiarEstado('Aprobada_Comercial')}
                    >
                      <i className="bi bi-check-circle me-1"></i>
                      Aprobar
                    </Button>
                    <Button
                      variant="danger"
                      onClick={() => handleCambiarEstado('Rechazada')}
                    >
                      <i className="bi bi-x-circle me-1"></i>
                      Rechazar
                    </Button>
                  </>
                )}

                {/* Comercial puede cancelar administrativamente en varios estados.
                    TIN-23: el cierre por entrega satisfactoria solo ocurre desde Revision_Entrega
                    (botón distinto, NO este). Este botón es una cancelación administrativa. */}
                {['Aprobada_Comercial', 'Enviada_Proveedor', 'Cotizacion_Recibida', 'Orden_Compra_Emitida', 'Orden_Compra_Aprobada', 'Orden_Enviada_Proveedor', 'Certificados_Pendientes', 'Certificados_Recibidos'].includes(requisicion.estado) && (
                  <Button
                    variant="outline-dark"
                    onClick={() => handleCambiarEstado('Cerrada')}
                    title="Cancela el proceso administrativamente (NO equivale a entrega satisfactoria). Para cerrar por entrega aceptada, usa 'Recibir a satisfacción y cerrar' desde Revisión de Entrega."
                  >
                    <i className="bi bi-x-octagon me-1"></i>
                    Cancelar proceso
                  </Button>
                )}

                {/* Técnico: cerrar cuando certs recibidos */}
                {requisicion.estado === 'Certificados_Recibidos' && (
                  <Button
                    variant="success"
                    onClick={() => handleCambiarEstado('Cerrada')}
                  >
                    <i className="bi bi-check2-all me-1"></i>
                    Confirmar y Cerrar
                  </Button>
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* TIN-23: Modal Seleccionar Ganador */}
      <SeleccionarGanadorModal
        show={showModalGanador}
        onHide={() => setShowModalGanador(false)}
        proveedoresAsignados={requisicion.proveedoresAsignados || []}
        onConfirmar={handleSeleccionarGanador}
      />

      {/* TIN-23: Modal Devolución */}
      <DevolucionModal
        show={showModalDevolucion}
        onHide={() => setShowModalDevolucion(false)}
        onConfirmar={handleConfirmarDevolucion}
      />

      {/* TIN-23 P1+P2: Modal de confirmación de correos antes de enviar/reenviar */}
      <ConfirmarEnvioEmailModal
        show={modalEnvioEmail.show}
        onHide={() => setModalEnvioEmail((prev) => ({ ...prev, show: false }))}
        titulo={modalEnvioEmail.titulo}
        descripcion={modalEnvioEmail.descripcion}
        proveedoresAsignados={modalEnvioEmail.proveedoresAsignados}
        confirmarLabel={modalEnvioEmail.reenvio ? 'Reenviar' : 'Enviar'}
        onConfirmar={async (envios) => {
          if (modalEnvioEmail.proveedoresAsignados.length > 1) {
            await ejecutarEnvioMasivo(envios);
          } else {
            await ejecutarEnvioLinks(envios);
          }
        }}
      />

      {/* MODAL AGREGAR PROVEEDOR — TIN-23 P4 */}
      <Modal show={showModalProveedor} onHide={() => setShowModalProveedor(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Agregar Proveedor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted small mb-3">
            Busca el proveedor en Tinvaz. Si no está, puedes buscarlo por NIT
            en el ERP externo (se creará automáticamente en Tinvaz al seleccionarlo).
          </p>
          <SelectorProveedorTercero
            value={selectorProveedorValue}
            onChange={setSelectorProveedorValue}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalProveedor(false)}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleAgregarProveedor}
            disabled={agregandoProveedor || !selectorProveedorValue?.proveedor}
            title={!selectorProveedorValue?.proveedor
              ? 'Selecciona un proveedor existente o créalo desde el ERP'
              : ''}
          >
            {agregandoProveedor ? (
              <>
                <Spinner animation="border" size="sm" className="me-1" />
                Agregando...
              </>
            ) : (
              <>
                <i className="bi bi-plus-circle me-1"></i>
                Agregar
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default RequisicionDetailPage;
